var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRfSignalsensor433 = function SvgRfSignalsensor433(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2.006c-2.305 0-4.61.878-6.363 2.63-3.506 3.507-3.506 9.221 0 12.728L7.05 15.95a6.984 6.984 0 0 1 0-9.899 6.984 6.984 0 0 1 9.898 0 6.984 6.984 0 0 1 0 9.899l1.414 1.414c3.507-3.506 3.507-9.22 0-12.727A8.97 8.97 0 0 0 12 2.006m0 4a4.99 4.99 0 0 0-3.535 1.459 5.014 5.014 0 0 0 0 7.07l1.414-1.414c-1.18-1.18-1.18-3.062 0-4.242s3.062-1.18 4.242 0 1.18 3.062 0 4.242l1.414 1.414a5.014 5.014 0 0 0 0-7.07A4.99 4.99 0 0 0 12 6.005M12 10a1 1 0 0 0-1 1v9H6v2h12v-2h-5v-9a1 1 0 0 0-1-1"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRfSignalsensor433);
export default ForwardRef;